import { z } from "zod";

import { emailSchema } from "~/screens/Auth/schemas/email.schema";

export const signupSchema = z
  .object({
    firstName: z.string().min(1, "First name is required."),
    lastName: z.string().min(1, "Last name is required."),
    email: emailSchema,
    acceptToS: z.boolean(),
  })
  .refine((data) => data.acceptToS === true, {
    message: "Terms of use is required.",
    path: ["acceptToS"],
  });
